import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router';

import BasePage from "../components/base/BasePage";

const Program= () => import('../views/program/program');
    const Invite = () => import('../views/invite/Invite');

    const User = () => import('../views/user/User');
const UserList = () => import('../views/user/UserList');
const Video = () => import('../views/video/Video');
const VideoList = () => import('../views/video/VideoList');

const Score= () => import('../views/score/Score');
const ScoreList = () => import('../views/score/ScoreList');
const Advise= () => import('../views/advise/advise');
const AdviseList= () => import('../views/advise/AdviseList');

const Record= () => import('../views/record/Record');
const RecordList = () => import('../views/record/RecordList');

const Share= () => import('../views/share/Share');
const ShareList = () => import('../views/share/ShareList');
const ShareConfig = () => import('../views/share/ShareConfig');

const Config= () => import('../views/config/Config');
const ConfigList = () => import('../views/config/ConfigList');

const CookieConfig= () => import('../views/cookie/CookieConfig');
const CookieConfigList = () => import('../views/cookie/CookieConfigList');

const Member= () => import('../views/member/Member');
const MemberList = () => import('../views/member/MemberList');

const Order= () => import('../views/order/Order');
const OrderList = () => import('../views/order/OrderList');

import Login from "../views/login/Login.vue";
import Register from "../views/register/Register.vue";
import Forget from "../views/forget/Forget.vue";
const Pay = () => import('../views/pay/Pay');
const Sign = () => import('../views/sign/Sign');
const PersonalCenter = () => import('../views/person/PersonalCenter');

const Statistics = () => import('../views/statistics/Statistics');
const StatisticsList = () => import('../views/statistics/StatisticsList');

const MessagePush = () => import('../views/messagePush/MessagePush');
const Menu = () => import('../views/menu/Menu');

const routes = [
    {
        path: '/',
        redirect: '/login'
    },

    {
        path: '/login',
        name: 'Login',
        component: Login
    },

    {
        path: '/register',
        name: 'Register',
        component: Register
    },

    {
        path: '/forget',
        name: 'Forget',
        component: Forget
    },

    {
        path: '/pay',
        name: 'Pay',
        component: Pay
    },

    {
        path: '/person',
        name: 'PersonalCenter',
        component: PersonalCenter
    },

    {
        path: '/sign',
        name: 'Sign',
        component: Sign
    },

    {
        path: '/advise',
        name: 'Advise',
        component: Advise
    },

    {
        path: '/pages',
        component: BasePage,
        children: [
            {
                path: "program",
                name: 'Program',
                component: Program,
                meta: { title: '系统配置' }
            },
            {
                path: "invite",
                name: 'Invite',
                component: Invite,
                meta: { title: '邀请规则' }
            },
            {
                path: "messagePush",
                name: 'MessagePush',
                component: MessagePush,
                meta: { title: '消息推送' }
            },
            {
                path: "menu",
                name: 'Menu',
                component: Menu,
                meta: { title: '菜单设置' }
            },
            {
                path: "config",
                name: 'Config',
                component: Config,
                children: [
                    {
                        path: "configList",
                        name: "ConfigList",
                        component: ConfigList,
                        meta: { title: '配置管理' }
                    },
                ]
            },
            {
                path: "cookieConfig",
                name: 'CookieConfig',
                component: CookieConfig,
                children: [
                    {
                        path: "cookieConfigList",
                        name: "CookieConfigList",
                        component: CookieConfigList,
                        meta: { title: 'Cookie管理' }
                    },
                ]
            },
            {
                path: "advise",
                name: 'Advise',
                component: Advise,
                children: [
                    {
                        path: "adviseList",
                        name: "AdviseList",
                        component: AdviseList,
                        meta: { title: '建议管理' }
                    },
                ]
            },
            {
                path: "video",
                name: 'Video',
                component: Video,
                children: [
                    {
                        path: "videoList",
                        name: "VideoList",
                        component: VideoList,
                        meta: { title: '提取记录' }
                    },
                ]
            },
            {
                path: "share",
                name: 'Share',
                component: Share,
                children: [
                    {
                        path: "shareList",
                        name: "ShareList",
                        component: ShareList,
                        meta: { title: '链接审核' }
                    },
                    {
                        path: "shareConfig",
                        name: "ShareConfig",
                        component: ShareConfig,
                        meta: { title: '分享设置' }
                    },
                ]
            },
            {
                path: "order",
                name: 'Order',
                component: Order,
                children: [
                    {
                        path: "orderList",
                        name: "OrderList",
                        component: OrderList,
                        meta: { title: '订单管理' }
                    },
                ]
            },
            {
                path: "member",
                name: 'Member',
                component: Member,
                children: [
                    {
                        path: "memberList",
                        name: "MemberList",
                        component: MemberList,
                        meta: { title: '会员管理' }
                    },
                ]
            },
            {
                path: "record",
                name: 'Record',
                component: Record,
                children: [
                    {
                        path: "recordList",
                        name: "RecordList",
                        component: RecordList,
                        meta: { title: '记录管理' }
                    },
                ]
            },
            {
                path: "user",
                name: 'User',
                component: User,
                children: [
                    {
                        path: "userList",
                        name: "UserList",
                        component: UserList,
                        meta: { title: '用户列表' }
                    },
                ]
            },
            {
                path: "score",
                name: 'Score',
                component: Score,
                children: [
                    {
                        path: "scoreList",
                        name: "ScoreList",
                        component: ScoreList,
                        meta: { title: '积分管理' }
                    },
                ]
            },
            {
                path: "statistics",
                name: 'Statistics',
                component: Statistics,
                children: [
                    {
                        path: "statisticsList",
                        name: "StatisticsList",
                        component: StatisticsList,
                        meta: { title: '仪表盘' }
                    },
                ]
            },
        ]
    },
];


const router = new createRouter({
    // history: createWebHistory(),
    history: createWebHashHistory (),
    mode: 'hash',
    routes
});

export default router;
